import { Stack } from '@mui/material';

import { Text, api } from 'common';

import { BlockValueTemplateFieldArea } from '../../../ConfigFields/CodeMirror/FlowTemplate';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const DocumentSearchVariant = {
  schema: PatientDataStore.DocumentSearchConfigSchema,
  Config: () => {
    return (
      <Stack spacing={2}>
        <Text variant="heading5" bold>
          Document Search
        </Text>
        <Stack spacing={2}>
          <BlockValueTemplateFieldArea
            fieldName="config.searchQuery"
            label="Search Query"
            placeholder='e.g. Get documents in the past 45 days indicating a diagnosis of atrial fibrillation or ICD code "{{codeMapping.atrialFibrillationIcdCode}}", where the document title contains "Visit Note"'
            helperText="To pull upstream data into the query, use {{upstreamBlockName.data}}."
          />
        </Stack>
      </Stack>
    );
  },
};
